<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${user.firstname} ${user.lastname}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="user" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "user-view-authorizations",

  components: { LogListTable },

  props: ["user"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
